import { render, staticRenderFns } from "./gasClamp.vue?vue&type=template&id=94ee1b9e&scoped=true"
import script from "./gasClamp.vue?vue&type=script&lang=js"
export * from "./gasClamp.vue?vue&type=script&lang=js"
import style0 from "./gasClamp.vue?vue&type=style&index=0&id=94ee1b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ee1b9e",
  null
  
)

export default component.exports